import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class AncientSea2 extends SlotGameType1_2
	{
		//override 
		////protected override freegameBonusFactory: FreegameBonusFactory2 = new AncientSeaFreegame2BonusFactory();
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/28 Days Later.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }


	}

// 	class AncientSea2Freegame extends FreegameBonus2
// 	{
// 		protected bonusTitle: HTMLElement = null;
// 		protected totalWin:HTMLElement = null;
		
// 		protected wonTitle:HTMLElement = null;
// 		protected payedTitle:HTMLElement = null;
// 		protected leftTitle:HTMLElement = null;

// 		protected wonValue:HTMLElement = null;
// 		protected payedValue:HTMLElement = null;
// 		protected leftValue:HTMLElement = null;
// 		protected titleAnim:HTMLElement = null;

// 		/* public TitlePrepare(resourceManager: IWriteOnlyResourceManager):void
// 		{
			
// 			resourceManager.Add(new SpriteResource(this.gameResourcesBasePath + "title_sprite", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
// 		} */

	
// 		/* public TitleLoaded(resourceManager: IReadOnlyResourceManager)
// 		{
// 			this.titleAnim = document.createElement("div");
// 			this.titleAnim.classList.add("AncientSea");
// 			SetStyles(this.titleAnim,{
// 				position:"absolute",
// 				height:"400px",
// 				width:"1920px",
// 				top:"0px"
// 			});


// 			this.titleSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, new Size(1920,400));
// 			this.titleSprite.ScaleNonUniform(1.5, 1);

// 			SetStyles(this.view.querySelector(".title"),
// 			{
// 				display:"flex",
// 				justifyContent:"center",
// 			});

			

// 			this.titleAnim.appendChild(this.titleSprite.View());
// 			this.view.appendChild(this.titleAnim);

// 			this.titleSprite.Start(true);
// 		} */

// 		public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
// 		{
// 			await super.ResourcesLoaded(resourceManager);
// 		}

	
// 	}

// 	class AncientSeaFreegame2BonusFactory extends FreegameBonusFactory2 
// 	{
// 		public override CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegameConfiguration,  p: FreegameBonus2Params): FreegameBonus2 
// 		{
// 			return new AncientSea2Freegame(gameName, freeGameConfig,  p);
// 		}
// 	}
// // }